<template>
  <div>
    <div class="d-flex justify-content-between">
      <h1 class="page-header">
        {{ $t('quarterlySaleProduct.pageTitle') }}
      </h1>
      <ts-breadcrumb
        :items="[
          { text: $t('home'), href: '/' },
          {
            text: $t('quarterlySaleProduct.pageTitle'),
            active: true
          }
        ]"
      />
    </div>
    <div class="row">
      <div class="col-md-3">
        <div class="form-group">
          <ts-card>
            <ts-card-wrapper>
              <ts-loading-banner :loading="loading">
                <form>
                  <fieldset>
                    <legend>
                      {{ $t('quarterlySaleProduct.criteria') }}
                    </legend>
                    <div class="row">
                      <div class="col-md-12">
                        <div class="form-group">
                          <label class="required">{{
                            $t('quarterlySaleProduct.dateRange')
                          }}</label>
                          <a-range-picker
                            format="DD-MM-YYYY"
                            :defaultValue="rangeDate"
                            :defaultPickerValue="rangeDate"
                            @change="dateRangeChange"
                            :ranges="{
                              Today: [moment(), moment()],
                              'This Month': [
                                moment().startOf('month'),
                                moment().endOf('month')
                              ]
                            }"
                          >
                            <template slot="renderExtraFooter"></template>
                          </a-range-picker>
                          <div class="validate" v-if="errors.has('date_range')">
                            {{ errors.first('date_range') }}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-md-12">
                        <div class="form-group">
                          <label>{{
                            $t('detailSaleByCustomerReport.customer')
                          }}</label>
                          <a-select
                            v-model="model.customer_id"
                            :options="customers"
                            class="ts-w-full"
                            showSearch
                            mode="multiple"
                             @search="onCustomerSearch"
                            :filterOption="
                              (input, option) =>
                                option.componentOptions.children[0].text
                                  .toLowerCase()
                                  .indexOf(input.toLowerCase()) >= 0
                            "
                            :placeholder="$t('all')"
                          >
                          </a-select>
                        </div>
                      </div>
                    </div>

                          <div class="row">
                      <div class="col-md-12">
                        <div class="form-group">
                          <label>{{
                            $t('detailSaleByCustomerReport.customerType')
                          }}</label>
                          <a-select
                            v-model="model.cus_type_id"
                            :options="customerTypes"
                            class="ts-w-full"
                            showSearch
                            mode="multiple"
                            :filterOption="
                              (input, option) =>
                                option.componentOptions.children[0].text
                                  .toLowerCase()
                                  .indexOf(input.toLowerCase()) >= 0
                            "
                            :placeholder="$t('all')"
                          >
                          </a-select>
                        </div>
                      </div>
                    </div>

                    <div class="row">
                      <div class="col-md-6 ts-text-right">
                        <ts-button
                          outline
                          color="success"
                          class="btn-block"
                          @click.prevent="exportExcel"
                          :waiting="exporting"
                          ><i class="far fa-file-excel"></i>
                          {{ $t('export') }}</ts-button
                        >
                      </div>
                      <div class="col-md-6 ts-text-right">
                        <ts-button
                          color="danger"
                          outline
                          class="btn-block"
                          @click.prevent="preview"
                          :waiting="waiting"
                          ><i class="far fa-file-pdf"></i>
                          {{ $t('preview') }}</ts-button
                        >
                      </div>
                    </div>
                  </fieldset>
                </form>
              </ts-loading-banner>
            </ts-card-wrapper>
          </ts-card>
        </div>
      </div>
      <div class="col-md-9">
        <ts-card>
          <ts-card-wrapper>
            <form>
              <fieldset>
                <legend>{{ $t('quarterlySaleProduct.preview') }}</legend>
                <ts-preview-pdf v-model="waiting" :src="src" />
              </fieldset>
            </form>
          </ts-card-wrapper>
        </ts-card>
      </div>
    </div>
  </div>
</template>

<script>
import { Errors } from 'form-backend-validation'
import moment from 'moment'
import { mapActions } from 'vuex'
import * as FileDownload from 'downloadjs'
import { trim } from 'lodash'

export default {
  name: 'quarterlySaleProductByCustomer',
  data() {
    return {
      exporting: false,
      waiting: false,
      loading: false,
      location_loading: false,
      errors: new Errors(),
      branches: [],
      src: '',
      rangeDate: [moment(), moment()],
      customers: [],
      customerTypes:[],
      model: {
        branch_id: [],
      }
    }
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.fetchData()
    })
  },
  methods: {
    ...mapActions('report/resource', [
      'getBranch',
      'getCustomer',
      'getCustomerType'
    ]),
    moment,
    async fetchData() {
      this.loading = true
      await this.getCustomerType().then(response => {
        this.customerTypes = response.data.map(el => ({
          value: el.cus_type_id,
          label: el.customer_type
        }))
      })
      await this.getCustomer().then(response => {
        this.customers = response.data.map(el => ({
          value: el.customer_id,
          label: el.customer_name
        }))
      })
      await this.getBranch()
        .then(response => {
          this.branches = response.data.map(el => ({
            value: el.branch_id,
            label: el.branch_name_en
          }))
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.loading = false
        })
    },
    preview() {
      this.errors = new Errors()
      this.waiting = true
      this.src = ''
      this.$store
        .dispatch('report/sale/quarterlySaleProductByCustomer', this.model)
        .then(response => {
          this.src = response.url
        })
        .catch(error => {
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
        })
        .finally(() => {
          this.waiting = false
        })
    },
    exportExcel() {
      this.exporting = true
      this.errors = new Errors()
      this.$store
        .dispatch('report/sale/quarterlySaleProductByCustomerExcel', this.model)
        .then(response => {
          let filename = trim(
            response.headers['content-disposition']
              .substring(
                response.headers['content-disposition'].indexOf('filename')
              )
              .replace('filename=', ''),
            '"'
          )
          FileDownload(response.data, filename)
        })
        .catch(err => {
          let error = JSON.parse(
            String.fromCharCode.apply(null, new Uint8Array(err))
          )
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
        })
        .finally(() => (this.exporting = false))
    },
    dateRangeChange(rangeDate) {
      this.$store.commit(
        'report/sale/SET_DATE_FROM',
        rangeDate[0].format('DD-MM-YYYY')
      )
      this.$store.commit(
        'report/sale/SET_DATE_TO',
        rangeDate[1].format('DD-MM-YYYY')
      )
    },
    async onCustomerSearch(input) {
    this.loading = true
    try {
      const response = await this.getCustomer({ searchCustomerName: input })
      this.customers = response.data.map(el => ({
        value: el.customer_id,
        label: el.customer_name
      }))
    } finally {
      this.loading = false
    }
  }
  },
  beforeRouteLeave(to, from, next) {
    this.$store.commit(
      'report/sale/SET_DATE_FROM',
      moment().format('DD-MM-YYYY')
    )
    this.$store.commit('report/sale/SET_DATE_TO', moment().format('DD-MM-YYYY'))
    next()
  }
}
</script>
